// eslint-disable-next-line import/prefer-default-export
export const getServerAdress = () => {
  let oRes = "https://node.koreliz.com";
  if (process.env.NODE_ENV === "development") {
    oRes = "http://localhost:5000";
  }
  return oRes;
};
